// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LongWriteAnswerCreateUpdate
 */
export interface LongWriteAnswerCreateUpdate {
  /**
   *
   * @type {string}
   * @memberof LongWriteAnswerCreateUpdate
   */
  blockId?: string | null
  /**
   *
   * @type {number}
   * @memberof LongWriteAnswerCreateUpdate
   */
  words?: number
  /**
   *
   * @type {string}
   * @memberof LongWriteAnswerCreateUpdate
   */
  answerText?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteAnswerCreateUpdate
   */
  plainText?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteAnswerCreateUpdate
   */
  eventId?: string | null
}

/**
 * Check if a given object implements the LongWriteAnswerCreateUpdate interface.
 */
export function instanceOfLongWriteAnswerCreateUpdate(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWriteAnswerCreateUpdateFromJSON(
  json: any,
): LongWriteAnswerCreateUpdate {
  return LongWriteAnswerCreateUpdateFromJSONTyped(json, false)
}

export function LongWriteAnswerCreateUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWriteAnswerCreateUpdate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    blockId: !exists(json, 'blockId') ? undefined : json['blockId'],
    words: !exists(json, 'words') ? undefined : json['words'],
    answerText: !exists(json, 'answerText') ? undefined : json['answerText'],
    plainText: !exists(json, 'plainText') ? undefined : json['plainText'],
    eventId: !exists(json, 'eventId') ? undefined : json['eventId'],
  }
}

export function LongWriteAnswerCreateUpdateToJSON(
  value?: LongWriteAnswerCreateUpdate | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    blockId: value.blockId,
    words: value.words,
    answerText: value.answerText,
    plainText: value.plainText,
    eventId: value.eventId,
  }
}
